import type { MultiSelectFilterFieldWrapperProps } from '../multi_select_filter_field/multi_select_filter_field_wrapper';
import { MultiSelectFilterFieldWrapper } from '../multi_select_filter_field/multi_select_filter_field_wrapper';
import {
  type MultiSelectFilterTextInputType,
  useTextFilterOptions,
} from '../multi_select_filter_field/option_hooks';

export type { MultiSelectFilterTextInputType };

type Props = Pick<
  MultiSelectFilterFieldWrapperProps,
  'name' | 'value' | 'onChange' | 'label' | 'subtitle' | 'vertical' | 'disabled'
> & {
  inputType?: MultiSelectFilterTextInputType;
};

export const MultiSelectFilterTextField = ({
  inputType = 'string',
  ...props
}: Props) => {
  const options = useTextFilterOptions(props.value, inputType);

  return (
    <MultiSelectFilterFieldWrapper
      {...props}
      loadOptions={options.loadOptions}
      resolveSelectedItems={options.resolveSelectedItems}
      itemLabels={options.itemLabels}
      showItemAvatar={options.showItemAvatar}
      showStartTypingHint={options.showStartTypingHint}
    />
  );
};
